
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useGetSavedQueriesQuery, useGetSharedQueriesQuery } from '../../../api/dataWranglerApiSlice';
import { useUserInfoQuery } from "../../../api/userApiSlice";
import {
    QueryTools, setAdvancedFields,
    setQueryWizard,
    setSelectedQueryTool
} from '../dataWranglerSlice';
import { QueryBuilderTypes } from '../types/QueryBuilderTypes';
import { useSelector } from "react-redux";
import { selectSelectedDatabase } from '../../common/databaseSlice';

export default function useUserQueries({ setOpen }: any) {
    const dispatch = useDispatch();
    const [selectedQueryType, setSelectedQueryType] = useState("own");
    const [selectedQuery, setSelectedQuery] = useState("-1");
    const selectedDatabase = useSelector(selectSelectedDatabase);
    const { data: queries } = useGetSavedQueriesQuery({ database: selectedDatabase });
    const { data: sharedQueries } = useGetSharedQueriesQuery({ database: selectedDatabase });
    const { data: userData } = useUserInfoQuery({});

    const queryTypes: any = {
        own: queries?.filter((query) => query.type !== 'core'),
        sharedByMe: queries?.filter((query) => query.type === 'shared'),
        shared: sharedQueries
    };

    const onSubmitLoadQuery = () => {
        const userQueries = findSelectedItemByIdInList(queries);
        const shared = findSelectedItemByIdInList(sharedQueries);
        const selected = userQueries || shared;
        if (selected) {
            const queryBuilder = selected.builder === QueryBuilderTypes.Wizard ? "queryWizard" : "dictionary"
            dispatchSelectedQuery(selected.query, queryBuilder);
        }
    }

    const dispatchSelectedQuery = (query: any, builder: QueryTools) => {
        dispatch(setSelectedQueryTool(builder));
        if(builder === "queryWizard"){
            dispatch(setQueryWizard(query));
        }
        else{
            dispatch(setAdvancedFields(query));
        }
        setOpen(false);
    }

    const shouldDisableMyQueriesButton = () => selectedQuery === "-1" || !(findSelectedItemByIdInList(queries));

    const shouldDisableSharedQueriesButton = () => {
        const isSelectedInvalid = selectedQuery === "-1";
        if (selectedQueryType === 'shared') {
            return isSelectedInvalid || !(findSelectedItemByIdInList(sharedQueries));
        }
        const isSharedByMeEmpty = queryTypes.sharedByMe.length <= 0;
        const isSharedByMeSelected = !(findSelectedItemByIdInList(queryTypes.sharedByMe));
        return isSelectedInvalid || isSharedByMeEmpty || isSharedByMeSelected;
    }

    const findSelectedItemByIdInList = (collection: any[] | undefined) => {
        return collection?.find((query: any) => query.id === selectedQuery);
    }

    const handleTabChange = (event: React.SyntheticEvent, newTab: string) => {
        setSelectedQueryType(newTab);
    }

    const shouldDisableLoadButton = () => {
        //Disable Load Button: If query is advanced and role includes "DUCREQUIRED"
        const selectedQueryData = queries?.find((q: any) => q.id === selectedQuery) ||
            sharedQueries?.find((q: any) => q.id === selectedQuery);
        const isAdvancedQuery = selectedQueryData?.builder !== "wizard";
        const isDUCRequired = userData?.roles?.includes("DUCREQUIRED") && !userData?.roles?.includes("ADMIN");
        const isSharedTab = selectedQueryType === 'shared' ? shouldDisableSharedQueriesButton() : shouldDisableMyQueriesButton();
        return (isAdvancedQuery && isDUCRequired) || isSharedTab;
    }

    return {
        queryTypes,
        selectedQueryType,
        handleTabChange,
        selectedQuery,
        setSelectedQuery,
        queries,
        sharedQueries,
        onSubmitLoadQuery,
        shouldDisableMyQueriesButton,
        shouldDisableSharedQueriesButton,
        shouldDisableLoadButton
    }
}